const emailTemplateInfoReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_EMAIL_TEMPLATE_INFO":
          return state;
      case "SET_EMAIL_TEMPLATE_INFO" :
          return action.info;
      case "NULL_EMAIL_TEMPLATE_INFO" :
          return action.info;
      default:
          return state;
    }
  }
  export default emailTemplateInfoReducer